/**
 * Represents AppAvailability, extending the backend AppAvailability.
 * @extends BackendAppAvailability
 */
import { AppAvailability as BackendAppAvailability } from "@longtail-education/superprep-data-model-frontend"

export class AppAvailability extends BackendAppAvailability {
  get isDevOnly() {
    return this.LT_DEV_WEB && !this.LT_PROD_WEB
  }
}
